import { DefaultButton, Icon, Stack } from "@fluentui/react";

import { DefaultCardTitle } from "../styles";

import ComplementaryDocumentsTable from "./ComplementaryDocumentTable";

import { Card } from "@/components/Shared/Card";
import { ITerm } from "@/modules/Terms/interfaces/ITerm.interface";

interface ContractComplementaryDocumentsProps {
  terms: ITerm[];
  canCreate?: boolean;
  onCreate?: () => void;
}

export function ContractComplementaryDocuments({
  terms,
  canCreate,
  onCreate
}: ContractComplementaryDocumentsProps): JSX.Element {
  return (
    <Stack verticalFill>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <DefaultCardTitle>
          <Icon iconName="FabricDocLibrary" style={{ marginRight: 10 }} />
          Documentos Complementares
        </DefaultCardTitle>

        {canCreate && onCreate && (
          <DefaultButton onClick={onCreate}>Criar</DefaultButton>
        )}
      </Stack>

      <Card borderRadius="1rem" padding="1rem">
        <Stack style={{ height: "100%" }}>
          <ComplementaryDocumentsTable terms={terms} />
        </Stack>
      </Card>
    </Stack>
  );
}
